import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";
import { DirectDataApiMapping } from "./directdata-api-mapping";
import { DirectDataApiModel } from "./directdata-api-model";
import { ApiParamModel } from "@app/manual/models/api-models/api-param-model";

@Component({
    selector: "app-directdata-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class DirectDataApiManualComponent extends ApiSpecComponent {
    // This will be set from the api manual
    pageId = "";

    apiPath = "";

    apiVersion = "v1";

    initSpecs() {
        const apiModel = this.getApiModelByPageId();
        const translationKey = DirectDataApiMapping.translationKey(this.pageId);
        const parameters = this.getApiParameters(apiModel, translationKey);

        return <ApiSpecificationModel>{
            name: this.translation.t(`directData.${translationKey}Name`),
            description: apiModel.description
                ? this.translation.t(`directData.${translationKey}Description`)
                : apiModel.description,

            httpMethod: "GET",
            path: `/directdata/${this.apiVersion}/${this.apiPath}`,
            parameters: parameters,
            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: [apiModel.response],
                },
            ],
        };
    }

    private getApiModelByPageId(): DirectDataApiModel {
        const mapping = DirectDataApiMapping.getMapping();

        const keys = this.pageId.split(":");
        let apiForPageId: any = mapping;
        for (const key of keys) {
            apiForPageId = apiForPageId[key];
        }

        // Store last entry as this will be the api path
        this.apiPath = keys[keys.length - 1];
        let versionRegEx = /^v\d+$/;
        const versionKey = keys.find((k) => versionRegEx.test(k));
        if (versionKey) {
            this.apiVersion = versionKey;
        }

        return apiForPageId;
    }

    private getApiParameters(apiModel: DirectDataApiModel, translationKey: string): ApiParamModel[] {
        const parameters: ApiParamModel[] = [];

        if (apiModel.hasSplitPathsOption) {
            const prettyName = this.translation.t(`directData.${translationKey}Name`).toLowerCase();

            parameters.push({
                name: "splitPaths",
                description: this.translation.t("parameters.directDataSplitPathsDescription", { name: prettyName }),
                in: "query",
                paramType: "boolean",
                required: false,
                example: "true",
            });
        }

        return parameters;
    }
}
